// MobileBottomNavbar.jsx — 5 liens essentiels + "Menu" (ouvre MobileNavDrawer
// pour tout le reste, cf. navModules.js). L'ancienne version exposait 6 liens
// fixes et ne donnait aucun accès aux ~25 autres pages sur mobile.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faPlus, faLayerGroup, faBullseye, faBars } from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  { to: "/dashboard/statistics", label: "Overview", icon: faChartLine },
  { to: "/dashboard/campaigns", label: "Campagnes", icon: faLayerGroup },
  { to: "/dashboard/create-ad", label: "Créer", icon: faPlus, primary: true },
  { to: "/dashboard/tracking", label: "Tracking", icon: faBullseye },
];

const MobileBottomNavbar = ({ onOpenMenu }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-md border-t border-gray-100"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-stretch justify-around">
        {NAV_ITEMS.map((item) => {
          const active = path === item.to || path.startsWith(item.to + "/");
          if (item.primary) {
            return (
              <Link
                key={item.to}
                to={item.to}
                aria-label={item.label}
                className="flex flex-col items-center justify-center -mt-5"
              >
                <span className="w-12 h-12 rounded-full bg-[#221C51] text-white flex items-center justify-center shadow-lg shadow-[#221C51]/30 active:scale-95 transition-transform">
                  <FontAwesomeIcon icon={item.icon} className="text-lg" />
                </span>
                <span className="text-[10px] font-semibold mt-1 text-[#221C51]">{item.label}</span>
              </Link>
            );
          }
          return (
            <Link
              key={item.to}
              to={item.to}
              aria-label={item.label}
              className="flex flex-col items-center justify-center gap-1 min-w-[56px] py-2.5 active:opacity-60 transition"
            >
              <FontAwesomeIcon icon={item.icon} className={`text-base ${active ? "text-[#221C51]" : "text-gray-400"}`} />
              <span className={`text-[10px] font-medium ${active ? "text-[#221C51]" : "text-gray-400"}`}>{item.label}</span>
              {active && <span className="absolute mt-7 w-1 h-1 rounded-full bg-[#221C51]" />}
            </Link>
          );
        })}
        <button
          onClick={onOpenMenu}
          aria-label="Menu"
          className="flex flex-col items-center justify-center gap-1 min-w-[56px] py-2.5 active:opacity-60 transition"
        >
          <FontAwesomeIcon icon={faBars} className="text-base text-gray-400" />
          <span className="text-[10px] font-medium text-gray-400">Menu</span>
        </button>
      </div>
    </div>
  );
};

export default MobileBottomNavbar;
